import {
  closeProjectML,
  closeProjectTree,
  joinToProjectGeoImportWorks,
  joinToProjectPickerProgress,
  joinToProjectSeismicImport,
  leaveProjectGeoImportWorks,
  leaveProjectPickerProgress,
  leaveProjectSeismicImport,
  openProjectML,
  openProjectTree,
  selectGeoImportWorksConnection,
  selectMLConnection,
  selectProgressConnection,
  selectProjectTreeConnection,
  selectSeismicImportProgressConnection,
  useAppDispatch,
  useAppSelector,
} from '@core/core/store'
import type { ProjectId } from 'common/types'
import { useEffect } from 'react'

export const useSignalR = (projectId: ProjectId) => {
  const dispatch = useAppDispatch()

  const mlcalcConnection = useAppSelector(selectMLConnection)
  const projectTreeConnection = useAppSelector(selectProjectTreeConnection)
  const seismicImportProgressConnection = useAppSelector(selectSeismicImportProgressConnection)
  const pickerProgressConnection = useAppSelector(selectProgressConnection)
  const geoImportWorksConnection = useAppSelector(selectGeoImportWorksConnection)

  useEffect(() => {
    if (mlcalcConnection) {
      dispatch(openProjectML(projectId))
    }
    return () => {
      dispatch(closeProjectML(projectId))
    }
  }, [mlcalcConnection])

  useEffect(() => {
    if (projectTreeConnection?.connectionId) {
      dispatch(openProjectTree(projectId))
    }
    return () => {
      dispatch(closeProjectTree(projectId))
    }
  }, [projectTreeConnection?.connectionId])

  useEffect(() => {
    if (seismicImportProgressConnection) {
      dispatch(joinToProjectSeismicImport(projectId))
    }
    return () => {
      dispatch(leaveProjectSeismicImport(projectId))
    }
  }, [seismicImportProgressConnection])

  useEffect(() => {
    if (geoImportWorksConnection) {
      dispatch(joinToProjectGeoImportWorks(projectId))
    }
    return () => {
      dispatch(leaveProjectGeoImportWorks())
    }
  }, [geoImportWorksConnection])

  useEffect(() => {
    if (pickerProgressConnection) {
      dispatch(joinToProjectPickerProgress(projectId))
    }
    return () => {
      dispatch(leaveProjectPickerProgress(projectId))
    }
  }, [pickerProgressConnection])
}
